import { HelpSection } from 'legacy/lut/components/widgets/public/partner360/helpButton/enums/HelpSection'

export const lfKbaseLinks = {
  [HelpSection.ProgramOfferings]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1588/aid/4222',
  [HelpSection.Completeness]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1590/aid/4719',
  [HelpSection.BasicInfo]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1590/aid/4308',
  [HelpSection.ContactInfo]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1590/aid/4311',
  [HelpSection.HpContact]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1590/aid/4723',
  [HelpSection.ShareOfBusiness]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1590/aid/4314',
  [HelpSection.MarketInfo]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1590/aid/4316',
  [HelpSection.FinancialAndSOB]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1650/aid/4648',
  [HelpSection.Planning]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1590/aid/4319',
  [HelpSection.KeyInitiatives]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1590/aid/4726',
  [HelpSection.Bridges]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1650/aid/4654',
  [HelpSection.MDFPlanning]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1650/aid/4656',
  [HelpSection.Graphs]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1590/aid/4317',
  [HelpSection.MasterDealer]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1650/aid/4658',
  [HelpSection.PBMAcknowledgment]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1590/aid/4729',
  [HelpSection.ManagerAcknowledgment]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1590/aid/4730',
  [HelpSection.PartnerAcknowledgment]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1590/aid/4731',
  [HelpSection.HistoryAcknowledgment]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1590/aid/4732',
}
